import { Suspense } from 'react';

import CourseCards from '@/components/course-cards';
import { HeaderButtonsPortal } from '@/components/header';
import JoinCourse from '@/components/join-course';

const CourseListPage = () => {
  return (
    <Suspense>
      <div className="flex flex-col gap-4 p-1 lg:p-8">
        <HeaderButtonsPortal>
          <JoinCourse />
        </HeaderButtonsPortal>
        <CourseCards />
      </div>
    </Suspense>
  );
};

export default CourseListPage;
